<script lang="ts" module>
  import { tv } from 'tailwind-variants';

  export interface ImpactTPIProps {
    tpi: number;
    hideSign?: boolean;
    hidePercentage?: boolean;
  }
</script>

<script lang="ts">
  let { tpi: tpiProp = 0, hideSign = true, hidePercentage = true }: ImpactTPIProps = $props();

  const styles = tv({
    base: 'w-fit rounded-sm p-1',
    variants: {
      dimension: {
        plus: 'bg-success',
        minus: 'bg-error ',
        neutral: 'bg-neutral',
      },
    },
  });

  let dimension: 'plus' | 'minus' | 'neutral' | undefined = $derived(
    tpiProp > 0 ? 'plus'
    : tpiProp < 0 ? 'minus'
    : 'neutral',
  );

  let tpiText: string = $derived(
    (hideSign ? ''
    : tpiProp >= 0 ? '+'
    : '-') +
      Math.abs(Math.floor(tpiProp)) +
      (hidePercentage ? '' : '%'),
  );
</script>

<div class={styles({ dimension })}>
  <p class="font-sans text-label-sm font-normal text-c-base">
    TPI:
    <strong class="font-semibold">{tpiText}</strong>
  </p>
</div>
